import { ExternalUser } from '../../domain/model/account/externalUser';
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../auth/authentication.service';

 
export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  const user = authService.getCurrentUser2() as (ExternalUser & { exp?: number }) | null;
  // An expired token used to pass this guard (only presence was checked), so the page
  // loaded, every API call answered 401 and the screen rendered empty. Treat expiry as
  // logged out and go back to login, remembering where the user was heading.
  const expired = !!user?.exp && user.exp * 1000 <= Date.now();
  if (user && !expired) {
    return true;
  }
  if (expired) { authService.logout(); }
  router.navigate(['/login'], { queryParams: { returnUrl: state.url, ...(expired ? { reason: 'expired' } : {}) } });
  return false;
};
